import type { GeneralParameters } from '../../general/parameters/general'
import type { SnapshotMap } from '../../general/snapshot-map'

import { AnalytixEvent } from '../../general/event'
import { Gate, seeds } from '../../general/gate'

type PlayerCloseParameters = Record<never, never>
const dummy = {}

/**
 * There is no actual `player_close` event sent from the client,
 * but we need one to close the player gate when the player is closed
 */
export class PlayerCloseEvent extends AnalytixEvent<PlayerCloseParameters> {
  name = '(player_close)'
  group = 'player'
  parameters = dummy as SnapshotMap<PlayerCloseParameters>
  sender = () => Promise.resolve(true)

  // `player_close` event closes player gate
  gates = [Gate.Closes(seeds.player)]

  // coalesce multiple consecutive `player_close` events
  override coalescing = true

  // `player_close` event should flush all player-related events
  // in the queue to ensure that they are not sent after player is closed
  override flushing = ['player_open', 'play_start', 'play_stop', 'cdn_info']

  // infinite expiration because we want to ensure that player gate is closed on player close.
  // this event is synchronous and does not rely on any parameters, so the only case it can
  // possible expire is when there is another event in front of it in the queue,
  // which took too long to process and caused this event to expire before it is processed.
  // to prevent this, we set infinite timeout here.
  override timeout = Infinity

  constructor() {
    super()
    this.verify()
  }

  validate(): false | [GeneralParameters, PlayerCloseParameters] {
    return [dummy, dummy]
  }
}
